import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerLeftUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowCornerLeftUp"><Path d="M19.5 20.5H9V4" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 8L9 3.5L4.5 8" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowCornerLeftUp;
